import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./finance.module.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import Button from "common/Button";
import Summary from "components/Finance/Summary";
import Managers from "components/Finance/Managers";
import ContainerHeader from "common/ContainerHeader";
import RequestPayout from "components/Finance/RequestPayout";
import { BurgerMenuContext } from "context/sidebar";
import { getAll } from "utils/queries";
import DataTable_ from "common/DataTable";
import OnBoardAccount from "components/Finance/onBoardScreen";

const Finance = () => {
  const burgerContext = useContext(BurgerMenuContext);

  const [accounts, setAccounts] = useState([]);
  const [totalCount, setTotalCount] = useState();

  const [payoutStatus, setPayoutStatus] = useState();

  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        burgerContext.setShowSideBar(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [burgerContext]);

  const updateSidebar = () => {
    // burgerContext.updateComp({comp:<BankAccount/>,right:true,isOpen:true})
    burgerContext.updateComp({
      comp: (
        <RequestPayout
          getAllStripeAccounts={getAllStripeAccounts}
          sidebarRef={sidebarRef}
        />
      ),
      right: true,
      isOpen: true,
    });
    burgerContext.setShowSideBar(true);
  };

  const updateonBoardSidebar = () => {
    // burgerContext.updateComp({comp:<BankAccount/>,right:true,isOpen:true})
    burgerContext.updateComp({
      comp: (
        <OnBoardAccount
          getAllStripeAccounts={getAllStripeAccounts}
          sidebarRef={sidebarRef}
        />
      ),
      right: true,
      isOpen: true,
    });
    burgerContext.setShowSideBar(true);
  };

  const getAllStripeAccounts = async ({ limit = 10, offset = 0 } ={}) => {
    try {
      const result = await getAll(
        `stripe/connectAccount?limit=${limit}&offset=${offset}`
      );
      console.log("resulsdfsdt is", result);
      const Data = result?.data?.data;
      if (Data?.data) {
        setAccounts(Data?.data);
        setTotalCount(Data?.totalCount);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect(() => {
  //   getAllStripeAccounts({});
  // }, []);
  useEffect(() => {
    getAllStripeAccounts({ limit: 10, offset: 0 });
  }, []);

  console.log("accounts", accounts);

  const columns = [
    {
      name: "Name",
      cell: (row) => (
        <span
        // onClick={() => toggleRow(row.id)}
        // style={{ color: "var(--primary-color)", cursor: "pointer" }}
        >
          {row.holder_name}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },

    {
      name: "Sum",
      selector: (row) => `GB ${row?.sum || 0}` || "_",
      sortable: true,
    },
  ];

  const getAllPayoutStatus = async () => {
    try {
      // const result = await getAll(`stripe/transfer/status`);
      const result = await getAll(`stripe/finance/sales`)
      console.log("resultsdf is", result);
      // setPayoutStatus(result?.data?.data || []);
      setPayoutStatus(result?.data || []);
    } catch (error) {}
  };

  useEffect(() => {
    getAllPayoutStatus();
  }, []);

  return (
    <>
      <ContainerHeader label="Finance" showAddButton={false} />
      <div className={styles.container}>
        <Tabs>
          <TabList className={styles.nestedTabList}>
            <Tab>Summary</Tab>
            {/* <Tab>Managers</Tab> */}
          </TabList>
          <TabPanel>
            <div className={styles.finance}>
              <div className={styles.Financeinfo}>
                <div>
                  {" "}
                  {/* {payoutStatus?.map((e, index) => {
                    return (
                      <span key={index}>
                        {`£${e?.count} ${e?.status}`}
                        {index < payoutStatus.length - 1 && "  / "}{" "}
                      </span>
                    );
                  })} */}
                  £{payoutStatus?.pending_price || 0} Pending / £{payoutStatus?.cleared_price || 0} Cleared
                </div>
                {/* <div>£3.60 Pending / £50.60 Cleared</div> */}
                <div>
                  (£5.00 minimum cleared funds required to enable payout)
                </div>
              </div>

              <div className={styles.requestButton}>
                <div className={styles.horizontalLine}></div>
                <Button
                  label={"Request OnBoard"}
                  onClick={() => {
                    updateonBoardSidebar();
                  }}
                />
                <Button
                  label={"Request Payout"}
                  onClick={() => {
                    updateSidebar();
                  }}
                />
              </div>

              <div className={styles.financeTabs}>
                <Summary />
              </div>
            </div>
          </TabPanel>
          {/* <TabPanel>
            <Managers />
          </TabPanel> */}
        </Tabs>
      </div>

      {/* <h2>Account Holders</h2>

      <DataTable_
        columns={columns}
        data={accounts}
        handlefetchData={getAllStripeAccounts}
        totalCount={totalCount}
        customStyles={{
          expanderCell: {
            style: {
              display: "none",
            },
          },
          expanderButton: {
            style: {
              display: "none",
            },
          },
        }}
      /> */}
    </>
  );
};

export default Finance;
